import React from 'react'
import { PDFViewer } from '@react-pdf/renderer'
import Dialog from '@mui/material/Dialog'
import 'moment/locale/es'
import './vistaPrevia.css'
import { PdfFile } from './PdfFile'

export const VistaPreviaPrint = ({ auth, infoEmp, dataPreview, viewOptions, open, setOpen, urlLogo, paymentStatus }) => {
    return (
        <div>
            <Dialog
                className='ContainerModalVistaPrevia'
                open={open}
                onClose={() => setOpen(false)}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <PDFViewer>
                    <PdfFile
                        auth={auth}
                        infoEmp={infoEmp}
                        dataPreview={dataPreview}
                        viewOptions={viewOptions}
                        urlLogo={urlLogo}
                        paymentStatus={paymentStatus}
                    />
                </PDFViewer>
            </Dialog>
        </div >
    );
}